const UserImage = ({
    guid,
    className = null,
    size = 64,
    border= false
}) => {

    const apiUrl = process.env.REACT_APP_API_URL;
    const borderThickness = Math.round(size / 16); // Arrotonda il valore per evitare decimali

    return (
        <img 
            style={{
                objectFit: "cover",
                width: size,
                height: size,
                padding: 0,
                border: border?`${borderThickness}px solid var(--bs-body-bg)`:null // Usa il valore arrotondato
            }} 
            className={`rounded-circle ${className}`} 
            src={`${apiUrl}/img?guid=${guid}`} 
            alt="User avatar" 
        />
    );
}

export default UserImage;
